import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Register from './Register';
import Login from './Login';
import Profile from './Profile';
import AdminRoute from './Adminroute';
import Unauthorized from './Unauthorized';
import NotFound from './Notfound';
import Worksheet from './Worksheet';

function App() {
    return (
        <Router>
            <Routes>
                <Route path="/register" element={<Register />} />
                <Route path='/worksheet' element={<Worksheet/>} /> 
                <Route path="/login" element={<Login />} />
                <Route path="/" element={<Login />} />
                <Route path="*" element={<NotFound />} /> 
                <Route
        path="/profile"
        element={
          <AdminRoute>
            <Profile />
          </AdminRoute>
        }
      />
                 <Route path="/unauthorized" element={<Unauthorized />} />
            </Routes>
        </Router>
    );
}

export default App;
